import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from '../services/header.service';
import { TokenManager } from '../Globals';
import { MainLoadingService } from '../services/main-loading.service';
import { ThemeSetting } from '../objects/ThemeObject';
import { ThemeSettingService } from '../services/theme-setting.service';

@Component({
  selector: 'app-action-and-navigate',
  templateUrl: './action-and-navigate.component.html',
  styleUrls: ['./action-and-navigate.component.css']
})
export class ActionAndNavigateComponent implements OnInit {

  private path: string;
  private data: any;
  private userId: string = '';
  private action: string = '';
  private parameter: string = '';
  isBusy: boolean = false;
  loaderConfig: any;

  constructor(private route: ActivatedRoute, private headerService: HeaderService, private tokenManager: TokenManager, 
    private router: Router, private mainLoadingService: MainLoadingService, private themeSettingService: ThemeSettingService) { 
    this.route.queryParams.subscribe(params => {
      if (params['userId']) this.userId = params['userId'];
      if (params['action']) this.action = params['action'];
      if (params['parameter']) this.parameter = params['parameter'];
    })
  }

  ngOnInit() {
    var themes:ThemeSetting = this.themeSettingService.getTheme();
    this.loaderConfig = themes;
    this.path = this.route.snapshot.paramMap.get("path");
    this.actionAndNavigate();
  }

  actionAndNavigate(){
    this.isBusy = true;
    this.headerService.actionAndNavigateNew(this.path, this.userId, this.action, this.parameter).subscribe(result => {
      // this.isBusy = false;
      var parse = JSON.parse(result);
      if (parse){
       if (parse["NavigateTo"]){
        if (parse["NavigateTo"].toLowerCase() == "login"){
          this.tokenManager.store("BRNHoldKey", parse["Key"]);
          this.router.navigate(['/' + parse["NavigateTo"]]);
         }
         else{
          this.tokenManager.delete("BRNHoldKey");
          this.tokenManager.store("BRNActionKey", parse["Key"]);
          this.router.navigate(['/' + parse["NavigateTo"]]);
         }
       }
       else{
        this.tokenManager.store("BRNHoldKey", parse["Key"]);
         this.router.navigate(['/login']);
       }
      }
    }, error => {
      this.isBusy = false;
    });
  }
}
